import type { NavItem, SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "Roamwood Tiny Homes",
    shortName: "Roamwood",
    description: "Handcrafted timber tiny houses on wheels, designed with you and built by hand in our workshop. Explore our models and request a quote.",
    url: getOrigin(),
    ogImage: 'https://roamwood-tiny-homes.cdn.modulify.website/site/og-image.jpg'
}

export const mainNav: NavItem[] = [
    { label: "Models", href: '/models' },
    { label: "How we build", href: '/process' },
    { label: "About", href: '/about' },
    { label: "FAQ", href: '/#faq' }
]

export const footerNav: { title: string, items: NavItem[] }[] = [
    {
        title: "Explore",
        items: [
            { label: "Our models", href: '/models' },
            { label: "Compare models", href: '/models#compare' },
            { label: "How we build", href: '/process' },
            { label: "Options and upgrades", href: '/process#options' }
        ]
    },
    {
        title: "Company",
        items: [
            { label: "About us", href: '/about' },
            { label: "Questions and answers", href: '/#faq' },
            { label: "Request a quote", href: '/contact' },
            { label: "Privacy notice", href: '/privacy' }
        ]
    }
]
